import User from '@ixigo/icons/user';
import { Avatar, AvatarFallback, AvatarImage } from '@ixigo/iui/avatar';
import { useSignedInUser } from '../../shared/use-signed-in-user';
import { userFullName } from '../../shared/user-name';
import { NAV_TEXT } from '../content';

// The signed-in user's photo or initials, from the ixigo login's user info
// (the creators backend doesn't send a name). The SDK fills the user in just
// after sign-in, from its cache on a returning session; until then, and for
// accounts without a name, the avatar shows a person icon.
export function AccountAvatar() {
	const { user } = useSignedInUser();
	const name = userFullName(user) || null;

	return (
		<Avatar size="lg" role="img" aria-label={name ?? NAV_TEXT.yourAccount}>
			{user?.profilePic ? <AvatarImage src={user.profilePic} alt="" /> : null}
			{/* iui turns a name into initials ("Riya Mehta" → "RM"). */}
			<AvatarFallback>{name ?? <User />}</AvatarFallback>
		</Avatar>
	);
}
